import * as React from 'react';

import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useAppContext } from '../contexts/AppContext';
import { useLanguage } from '../contexts/LanguageContext'; // ✅ Import Language Context
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const Review = () => {
  const { appState } = useAppContext();
  const { translations } = useLanguage(); // ✅ Get translations


  return (
    <Stack spacing={2}>
      <List disablePadding>
        <ListItem sx={{ py: 1, px: 0 }}>
        <ListItemText primary={translations.store_creation_section.store_name} />
        <Typography variant="body2">{appState.newStoreAddress.storeName}</Typography>
        </ListItem>
        <ListItem sx={{ py: 1, px: 0 }}>
        <ListItemText primary={translations.store_creation_section.store_contact} />
        <Typography variant="body2">{appState.newStoreAddress.phone}</Typography>
        </ListItem>
      <Divider />
        <ListItem sx={{ py: 1, px: 0, display: 'flex', flexDirection: 'column' }}>
        <ListItemText primary={translations.store_creation_section.address} sx={{ sm: 12 }} />
        <Typography variant="body2" sx={{sm:12, md:6}}>{appState.newStoreAddress.address1 + ', ' + appState.newStoreAddress.city + ', ' + appState.newStoreAddress.postalCode + ', ' + appState.newStoreAddress.country}</Typography>
        </ListItem>
      </List>
      <Divider />

      <Typography sx={{alignSelf:'center'}} variant="body2"  >
      {translations.store_creation_section.rewards}
      </Typography>
      <TableContainer component={Paper} >
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
          <TableCell>{translations.store_creation_section.reward_name}</TableCell>
          <TableCell align="right">{translations.store_creation_section.reward_points}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {appState.newStoreRewards.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    </Stack>
  );
}

export default Review;